import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const LegalFeeModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  feeAmount, onFeeAmountChange, feeAmountError, setFeeAmountError,
  reason, onReasonChange, reasonError, setReasonError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Legal fee payment'
    buttonLabel='Pay'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputTextSF type='text' name='feeAmount' label='Fee amount' maxLength={100}
      value={feeAmount} onChange={onFeeAmountChange}
      error={feeAmountError} setError={setFeeAmountError}
      help='18% GST will be added'
    />

    <InputTextAreaSF type='text' name='reason' label='Reason for charging legal cost'
      value={reason} onChange={onReasonChange}
      error={reasonError} setError={setReasonError}
    />

  </ModalFormUI>

export default LegalFeeModalUI
